module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-2.ab557bc5.png";